import './pager.scss';
import axios from 'axios';
import { createElementFromHTML } from '../../utilities/js/helper';

class Pager {
    constructor ($pager, options) {

        const settings = {};

        this.settings = Object.assign({}, settings, options);

        this.$pager = $pager;
        this.$pagerButton = this.$pager.querySelector('.pager__button');
        this.$form = this.$pager.closest('form');
        this.$itemsCounter = this.$form?.querySelector('#items_per_page');
        this.$results = document.querySelector('[data-pager-results]');
    }

    initialize () {
        if (this.$form) {
            this.setEvents();
        }
    }

    // FUNCTION – add next content
    addNextContent (result) {
        // append a single html element
        if (result.innerHTML) {
            this.$results.querySelector('.teaser-grid__items').appendChild(result);
            const contentUpdateEvent = new CustomEvent('content.loaded', {
                view: window,
                bubbles: true,
                cancelable: false,
                detail: {
                    $context: result
                }
            });

            window.dispatchEvent(contentUpdateEvent);
        } else {
            // init all new elements via pseudo wrapper
            const pseudoResultWrapper = document.createElement('div');
            result.forEach(element => {
                pseudoResultWrapper.appendChild(element);
            });

            const contentUpdateEvent = new CustomEvent('content.loaded', {
                view: window,
                bubbles: true,
                cancelable: false,
                detail: {
                    $context: pseudoResultWrapper
                }
            });
    
            window.dispatchEvent(contentUpdateEvent);

            let $firstNewFocusElement = null;

            // append an array of html elements
            result.forEach((element, i) => {
                if (i === 0) {
                    $firstNewFocusElement = element.querySelector('a');
                }

                this.$results.querySelector('.teaser-grid__items').appendChild(element);
            });

            if ($firstNewFocusElement !== null) {
                setTimeout(() => {
                    $firstNewFocusElement.focus();
                }, 200);
            }
        }
    }

    // FUNCTION – Update Pager
    updatePager () {
        const pager = this.$results.querySelector('[data-pager]');

        if (pager) {
            pager.remove();
        }

        if (this.$newPager !== null) {
            this.$results.appendChild(this.$newPager);
            const contentUpdateEvent = new CustomEvent('content.loaded', {
                view: window,
                bubbles: true,
                cancelable: false,
                detail: {
                    $context: this.$newPager
                }
            });
    
            window.dispatchEvent(contentUpdateEvent);
        }
    }

    // AJAX – for load more content
    loadMore (href) {
        const formData = new FormData(this.$form);

        axios({
            method: 'post',
            url: href,
            data: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
            .then((result) => {
                const ajaxResult = JSON.parse(result.request.responseText);
                this.$filterResult = createElementFromHTML(ajaxResult.list);
                this.$newPager = createElementFromHTML(ajaxResult.pager);

                this.addNextContent(this.$filterResult);
                this.updatePager();
            })

            .catch((error) => {
                throw Error(error);
            });
    }

    setEvents () {        
        this.$pagerButton?.addEventListener('click', (e) => {
            this.loadMore(this.$pagerButton.getAttribute('href'));
            e.preventDefault();
        });
    }
}

export { Pager };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-pager]');
        $$roots.forEach($root => {
            const $rootAPI = new Pager($root);
            $rootAPI.initialize();
        });
    }
});
